// ═══════════════════════════════════════════════════════════════════════════
// PhoneMock — mockup stylisé de l'écran Accueil de l'app, utilisé dans le
// hero et la section split. Toujours sombre (c'est l'app).
// ═══════════════════════════════════════════════════════════════════════════

import { Bell } from "lucide-react";
import { STRINGS } from "../i18n";

// Mêmes photos de tête que celles utilisées dans la hero (sociaux proof).
const headPhotoModules = import.meta.glob(
  "../assets/headpicture/*.{jpg,jpeg,png}",
  { eager: true, as: "url" }
);
const PM_PHOTOS = Object.keys(headPhotoModules)
  .sort()
  .map((k) => headPhotoModules[k]);
const PM_AV_FALLBACK = ["#3624A6", "#0F47B3", "#4B34E0", "#6249FF"];

const PhoneAvatar = ({ i, size = 26, ring = "#0a0f14" }) => {
  const src = PM_PHOTOS[i % Math.max(PM_PHOTOS.length, 1)];
  const baseStyle = {
    width: size,
    height: size,
    borderRadius: "50%",
    flexShrink: 0,
    border: `2px solid ${ring}`,
    marginLeft: i === 0 ? 0 : -9,
  };
  return (
    <div
      style={
        src
          ? {
              ...baseStyle,
              // Quoté car les noms de fichiers contiennent ( ) et des espaces.
              backgroundImage: `url("${src}")`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : {
              ...baseStyle,
              background: PM_AV_FALLBACK[i % PM_AV_FALLBACK.length],
            }
      }
    />
  );
};

const PhoneMock = ({ float = true, lang = "fr" }) => {
  const t = (STRINGS[lang] && STRINGS[lang].phone) || STRINGS.fr.phone;
  return (
    <div className={`pm-wrap ${float ? "pm-float" : ""}`}>
      <div className="pm-frame">
        <div className="pm-notch" />
        <div className="pm-screen">
          {/* status bar — heure seule à gauche, icônes natives retirées */}
          <div className="pm-status">
            <span>9:41</span>
            <span />
          </div>

          {/* header — cloche notif + avatar profil (vraie photo) */}
          <div className="pm-header">
            <span className="pm-logo">Dispo</span>
            <div style={{ display: "flex", gap: 7 }}>
              <span
                className="pm-hbtn"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#f5f5f5",
                }}
              >
                <Bell size={15} strokeWidth={2.2} />
              </span>
              <span
                className="pm-hbtn pm-hbtn-av"
                style={
                  PM_PHOTOS.length > 0
                    ? {
                        backgroundImage: `url("${PM_PHOTOS[0]}")`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }
                    : undefined
                }
              />
            </div>
          </div>

          {/* greeting */}
          <div className="pm-greet">
            <div className="pm-greet-hi">{t.greetHi}</div>
            <div className="pm-greet-big">{t.greetBig}</div>
          </div>

          {/* hero cta */}
          <div className="pm-hero">
            <div className="pm-hero-eyebrow">{t.heroEyebrow}</div>
            <div className="pm-hero-title">
              {t.heroTitleL1}
              <br />
              {t.heroTitleL2}
            </div>
            <div className="pm-hero-arrow">→</div>
          </div>

          {/* section label */}
          <div className="pm-seclabel">{t.mineLabel}</div>

          {/* dispo rows */}
          <div className="pm-row">
            <div
              className="pm-row-emoji"
              style={{ background: "rgba(244,114,182,0.20)" }}
            >
              🍷
            </div>
            <div className="pm-row-info">
              <div className="pm-row-title">{t.row1Title}</div>
              <div className="pm-row-sub">
                {t.row1Sub}{" "}
                <span className="pm-chip pm-chip-green">✓ 4/6</span>
              </div>
            </div>
            <div className="pm-row-arrow">›</div>
          </div>
          <div className="pm-row">
            <div
              className="pm-row-emoji"
              style={{ background: "rgba(139,92,246,0.22)" }}
            >
              🎮
            </div>
            <div className="pm-row-info">
              <div className="pm-row-title">{t.row2Title}</div>
              <div className="pm-row-sub">
                {t.row2Sub}{" "}
                <span className="pm-chip pm-chip-green">✓ 6/6</span>
              </div>
            </div>
            <div className="pm-row-badge">3</div>
          </div>

          {/* crew label */}
          <div className="pm-seclabel">{t.crewLabel}</div>
          <div className="pm-feed">
            <div className="pm-feed-head">
              <PhoneAvatar i={0} size={28} />
              <div style={{ flex: 1 }}>
                <div className="pm-feed-name">Marie L.</div>
                <div className="pm-feed-time">{t.feedTime}</div>
              </div>
              <span className="pm-pill">{t.feedPill}</span>
            </div>
            <div className="pm-feed-body">
              <span className="pm-feed-emoji">🍷</span>
              <span className="pm-feed-text">{t.feedText}</span>
            </div>
            <div className="pm-feed-foot">
              <div style={{ display: "flex" }}>
                {[0, 1, 2, 3].map((i) => (
                  <PhoneAvatar key={i} i={i} size={24} />
                ))}
              </div>
              <span className="pm-feed-cta">{t.feedCta}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneMock;
